import { MUI, ThemeMode } from 'ci-esi-web-shared';

export function useIsDarkMode() {
  const {
    palette: { mode },
  } = MUI.useTheme();

  return mode === ThemeMode.DARK;
}
